import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateTopHeader, uplodateLoading, updateBankWithdraw, clearBankWithdrawCache, updateSingleWithdrawStatus, updateMultipleWithdrawStatus } from '../../../redux/features/common/commonSlice';
import { selectBankWithdrawPages, selectBankWithdrawIsLoaded, selectBankWithdrawPagerecord } from '../../../redux/features/common/selectors';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';
import { Box, Pagination, Button, Modal, TextField, Typography, Divider, IconButton } from '@mui/material'; // Added Divider, IconButton
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import InsufficientPermission from '../../custom/InSufficientPermission';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { v4 as uuidv4 } from 'uuid';
import DownloadIcon from '@mui/icons-material/Download'; // Optional: Add icons if you have mui icons installed
import SendIcon from '@mui/icons-material/Send';
import { formatIndianNumber } from '../../lib/formatIndianNumber';
import { getWithdrawUserName, getWithdrawTxnId } from '../../lib/withdrawDisplay';

const style = { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2 };

export const BankWithdrawManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector(state => state?.userData);

  // --- ENV CONSTANTS ---
  const DEBIT_ACC_NO = process.env.REACT_APP_ICICI_DEBIT_ACC_NO || "ADD_ACC_NO_IN_ENV";
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8765";
  const UPLOAD_ENDPOINT = "/api/admin-service/bank-withdraw/send-file";

  const [page, setPage] = useState(1);
  const [pageSizeInput, setPageSizeInput] = useState(25);

  const pages = useSelector(selectBankWithdrawPages);
  const datalist = pages[page] || [];
  const isLoaded = useSelector(selectBankWithdrawIsLoaded);
  const [pendingUpdates, setPendingUpdates] = useState(null);
  const pagerecord = useSelector(selectBankWithdrawPagerecord);
  const [callAPi, setCallAPi] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState("PENDING");

  const isInitialMount = useRef(true);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedWithdraw, setSelectedWithdraw] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showSendModal, setShowSendModal] = useState(false);
  const [sendSummary, setSendSummary] = useState({ totalAmount: 0, totalRecords: 0 });
  const userPermisiions = useSelector(state => state?.permission);

  let currentModulePermission;
  let viewPermission = true;
  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => element.moduleId === '31')?.permissions;
    if (currentModulePermission) {
      viewPermission = currentModulePermission.find((element) => element.name === 'VIEW')?.isEnable;
    }
  }

  useEffect(() => { 
    dispatch(updateTopHeader("Bank Withdraw Manager")); 
    dispatch(uplodateLoading(false));
  }, []);

  useEffect(() => {
    if (pagerecord.pageSize) {
      setPageSizeInput(pagerecord.pageSize);
    }
  }, [pagerecord.pageSize]);

  useEffect(() => {
    const hasCache = !!pages[page];
    getWithdrawHistory(hasCache, page);
  }, [page, callAPi]);

  const handlePageSizeInputChange = (e) => setPageSizeInput(e.target.value);
  const handlePageSizeSubmit = () => {
    let val = Number(pageSizeInput);
    if (val < 1 || isNaN(val)) val = 25; else if (val > 500) val = 500;
    setPageSizeInput(val);
    if (val !== pagerecord.pageSize) {
      dispatch(clearBankWithdrawCache());
      setPage(1);
      getWithdrawHistory(false, 1, val);
    }
  };
  const formatAmount = (amount) => {
    if (!amount) return 0;
    const num = Number(amount);
    return (num - Math.floor(num)) <= 0.5 ? Math.floor(num) : Math.ceil(num);
  };
  const getFormattedDateForExcel = (dateString) => {
    const date = dateString ? new Date(dateString) : new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"][date.getMonth()];
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${date.getFullYear()}`;

  };
  const getFileNameDate = () => {
    const date = new Date();
    return `${String(date.getDate()).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, '0')}${date.getFullYear()}_${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}`;
  };



  // Code for Download (New format: YYYYMMDD)
  const getDisplayFileNameDate = () => {
    const date = new Date();
    return `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}`;
  };

  const getWithdrawHistory = async (
    silent = false,
    customPage = page,
    customPageSize = pagerecord.pageSize,
    customSearch = searchText,
    customStartDate = startDate,
    customEndDate = endDate,
    customStatus = status
  ) => {
    try {
      if (!silent) {
        dispatch(uplodateLoading(true));
      }
      let postJson = {
        sort: 'createdAt',
        order: false,
        page: customPage - 1,
        limit: customPageSize,
        txnId: '',
        search: customSearch?.trim() || '',
        startDate: customStartDate || null,
        endDate: customEndDate || null,
        status: customStatus === "ALL" ? "" : customStatus
      };
      let res = await ApiCaller.post(postJson, urls.bankWithdrawHistory, userData?.access_token);
      const response = await res.response.json();
      const apiData = response.data && response.data.data ? response.data.data : response.data;
      if (['OK', 200, '200'].includes(response.status) || response.code === '200') {
        if (!silent) {
          dispatch(uplodateLoading(false));
        }
        const items = Array.isArray(apiData?.items) ? apiData.items : (Array.isArray(apiData?.records) ? apiData.records : []);
        const newPagerecord = {
          totalItems: apiData.totalItems || apiData.totalRecords || 0,
          totalPages: apiData.totalPages || 1,
          pageNumber: (typeof apiData.pageNumber === 'number' ? apiData.pageNumber + 1 : customPage),
          pageSize: apiData.pageSize || customPageSize
        };

        if (silent) {
          const cachedList = pages[customPage] || [];
          const hasChanges = items.length !== cachedList.length || items.some((item, idx) => {
            const cachedItem = cachedList[idx];
            return !cachedItem || cachedItem.txnId !== item.txnId || cachedItem.status !== item.status;
          });
          if (hasChanges) {
            setPendingUpdates({ pageNumber: customPage, datalist: items, pagerecord: newPagerecord });
          } else {
            setPendingUpdates(null);
          }
        } else {
          dispatch(updateBankWithdraw({ pageNumber: customPage, datalist: items, pagerecord: newPagerecord }));
          setPendingUpdates(null);
        }
      } else {
        if (!silent) {
          dispatch(uplodateLoading(false));
        }
        showDangerToast(response.message);
      }
    } catch (error) {
      if (!silent) {
        dispatch(uplodateLoading(false));
      }
      showDangerToast(error.message);
    }
  };

  // --- REJECT HANDLERS ---
  const handleRejectClick = (item) => { setSelectedWithdraw(item); setRejectReason(""); setShowRejectModal(true); };
  const handleSubmitReject = async () => {
    if (!rejectReason.trim()) { showDangerToast("Enter reason"); return; }
    try {
      dispatch(uplodateLoading(true));
      const isProcessing = selectedWithdraw?.status === 'PROCESSING';
      const postJson = isProcessing
        ? { txnId: selectedWithdraw.txnId, status: 'REJECTED' }
        : { txnId: selectedWithdraw.txnId, remarks: rejectReason };
      const apiUrl = isProcessing ? urls.updateBankWithdrawStatus : urls.rejectBankWithdraw;
      let res = await ApiCaller.post(postJson, apiUrl, userData?.access_token);
      const response = await res.response.json();
      const apiMessage = response?.data?.message || response?.message;
      if (['OK', 200, '200'].includes(response.status) || response.code === '200') {
        dispatch(uplodateLoading(false));
        showToast(apiMessage || 'Rejected Successfully');
        setShowRejectModal(false);
        dispatch(updateSingleWithdrawStatus({ txnId: selectedWithdraw.txnId, status: 'REJECTED' }));
        setSelectedWithdraw(null);
        getWithdrawHistory(true);
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(apiMessage || 'Reject failed');
      }
    } catch (error) { dispatch(uplodateLoading(false)); showDangerToast(error.message); }
  };

  // ranith 2025-12-06 - [Start] - [Process OUT Files Handler]
  const handleProcessOutFiles = async () => {
    try {
      dispatch(uplodateLoading(true));
      let res = await ApiCaller.post({}, urls.processOutFiles, userData?.access_token);
      const response = await res.response.json();

      if (['OK', 200, '200'].includes(response.status) || response.code === '200') {
        dispatch(uplodateLoading(false));
        // Check if data array is empty
        if (response?.data?.data && response?.data?.data?.length === 0) {
          showToast("No files available to update");
        } else {
          showToast("Update was successful");
        }
        getWithdrawHistory(); // Refresh the list
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message || "Failed to process OUT files");
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      console.error(error);
      showDangerToast(error.message || "Something went wrong");
    }
  };
  // ranith 2025-12-06 - [End] - [Process OUT Files Handler]

  // --- PREPARE SEND HANDLER ---
  const handlePrepareSend = () => {
    const pendingItems = datalist.filter(item => item.status === 'PENDING');
    if (pendingItems.length === 0) {
      showDangerToast("No 'PENDING' records found to generate file.");
      return;
    }

    const total = pendingItems.reduce((sum, item) => sum + (Number(item.finalAmount) || 0), 0);
    setSendSummary({
      totalAmount: total,
      totalRecords: pendingItems.length
    });
    setShowSendModal(true);
  };

  // --- EXPORT & UPLOAD LOGIC ---

  // Helper to generate Excel Blob
  const generateExcelBlob = (data) => {
    const accountNumber = "043905018684";
    const headerRow = ["Unique Transaction Ref No", "Debit Ac No", "Beneficiary Ac No", "Beneficiary Name", "Amt", "Pay Mode", "Date", "IFSC", "Payable Location name", "Print Location", "Bene Mobile no", "Bene email id", "Ben add1", "Ben add2", "Ben add3", "Ben add4", "Add details 1", "Add details 2", "Add details 3", "Add details 4", "Add details 5", "Remarks"];
    const bodyData = data.map((item) => {
      const amt = formatAmount(item.finalAmount);
      return [item.txnId || '', accountNumber, item.accountNumber || item.bankAccount || '', item.accountHolder || '', amt, "N", getFormattedDateForExcel(item.createdAt), item.ifsc || '', '', '', item.mobile || '', item.email || '', item.benAdd1 || '', item.benAdd2 || '', item.benAdd3 || '', item.benAdd4 || '', '', '', '', '', '', item.remarks || "Bank Cash Withdraw Request"];
    });

    const ws = XLSX.utils.aoa_to_sheet([headerRow, ...bodyData]);
    const rangeAll = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = rangeAll.s.r; R <= rangeAll.e.r; ++R) {
      for (let C = rangeAll.s.c; C <= rangeAll.e.c; ++C) {
        const addr = XLSX.utils.encode_cell({ r: R, c: C });
        if (ws[addr]) {
          ws[addr].t = "s";
          ws[addr].v = String(ws[addr].v);
          ws[addr].z = "@";
        }
      }
    }

    const yellowStyle = { fill: { fgColor: { rgb: "FFFF00" } }, font: { bold: true }, alignment: { horizontal: "center" }, border: { top: { style: "thin" }, bottom: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" } } };
    const normalStyle = { font: { bold: true }, alignment: { horizontal: "center" } };
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!ws[address]) continue;
      if ([1, 2, 3, 4, 6, 7].includes(C)) ws[address].s = yellowStyle; else ws[address].s = normalStyle;
    }
    ws['!cols'] = [{ wch: 25 }, { wch: 20 }, { wch: 20 }, { wch: 25 }, { wch: 10 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 30 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Payouts");
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    return new Blob([wbout], { type: 'application/vnd.ms-excel' });
  };

  const exportToExcel = async (isUpload = false) => {
    // 1. FILTER LOGIC: If uploading, ONLY take PENDING items
    let dataToExport = datalist;
    if (isUpload) {
      dataToExport = datalist.filter(item => item.status === 'PENDING');
      if (dataToExport.length === 0) {
        showDangerToast("No 'PENDING' records found to generate file.");
        return;
      }
    } else {
      if (!datalist || datalist.length === 0) {
        showDangerToast("No data to export");
        return;
      }
    }

    try {
      if (isUpload) dispatch(uplodateLoading(true));
      const blob = generateExcelBlob(dataToExport);

      // 1. Always Download (user wants this locally) - New Format
      const downloadFileName = `DZAPPS_DZAPPSUPLDX_${getDisplayFileNameDate()}.xlsx`;
      saveAs(blob, downloadFileName);

      // 2. If it's a "Send to Bank" action, also upload - Old Format
      if (isUpload) {
        const uploadFileName = `DZAPPS_DZAPPSUPLDX_${getFileNameDate()}.xlsx`;
        const uploadSuccess = await uploadFileToApi(blob, uploadFileName);
        if (uploadSuccess) {
          await markAsProcessing(dataToExport);
        }
      }
    } catch (error) { console.error("Export Error:", error); showDangerToast("Error generating file"); }
    finally { if (isUpload) dispatch(uplodateLoading(false)); }
  };

  // --- SINGLE USER PAY HANDLER ---
  const markAsProcessing = async (items) => {
    try {
      const txnIds = items.map(item => item.txnId);
      let postJson = { txnIds: txnIds };

      let res = await ApiCaller.post(postJson, urls.updatePaymentProcessing, userData?.access_token);
      const response = await res.response.json();

      if (['OK', 200, '200'].includes(response.status) || response.code === '200') {
        showToast("Transactions marked as Processing");
        if (txnIds.length === 1) {
          dispatch(updateSingleWithdrawStatus({ txnId: txnIds[0], status: 'PROCESSING' }));
        } else {
          dispatch(updateMultipleWithdrawStatus({ txnIds, status: 'PROCESSING' }));
        }
        getWithdrawHistory(true);
      } else {
        console.error("Failed to update status:", response);
        showDangerToast("File sent, but failed to update status: " + response.message);
      }
    } catch (error) {
      console.error("markAsProcessing Error:", error);
      showDangerToast("File sent, but error updating status.");
    }
  };

  // --- SINGLE USER PAY HANDLER ---
  const [showSinglePayModal, setShowSinglePayModal] = useState(false);
  const [selectedSinglePayItem, setSelectedSinglePayItem] = useState(null);

  const handleSinglePay = (item) => {
    if (item.status !== 'PENDING') {
      showDangerToast("Can only pay PENDING requests.");
      return;
    }
    setSelectedSinglePayItem(item);
    setShowSinglePayModal(true);
  };

  const confirmSinglePay = async () => {
    try {
      if (!selectedSinglePayItem) return;

      const item = selectedSinglePayItem;
      setShowSinglePayModal(false); // Close Modal

      dispatch(uplodateLoading(true));


      // SAFETY CHECK: Ensure we are processing ONLY the selected item in an array of length 1
      const blob = generateExcelBlob([item]);

      const downloadFileName = `DZAPPS_DZAPPSUPLDX_${getDisplayFileNameDate()}_${item.txnId || 'SINGLE'}.xlsx`;
      const uploadFileName = `DZAPPS_DZAPPSUPLDX_${getFileNameDate()}_${item.txnId || 'SINGLE'}.xlsx`;

      // 1. Download File (New format)
      saveAs(blob, downloadFileName);

      // 2. Upload to API (Old format)
      const uploadSuccess = await uploadFileToApi(blob, uploadFileName);

      // 3. Update Status if Upload Success
      if (uploadSuccess) {
        await markAsProcessing([item]);
      }

    } catch (error) {
      console.error("Single Pay Error:", error);
      showDangerToast("Error processing single payment");
    } finally {
      dispatch(uplodateLoading(false));
      setSelectedSinglePayItem(null);
    }
  };

  const uploadFileToApi = async (blob, fileName) => {
    try {
      // dispatch(uplodateLoading(true)); // Already handled in caller

      const file = new File([blob], fileName, { type: "application/vnd.ms-excel" });
      const formData = new FormData();
      formData.append("file", file);

      // Use ApiCaller.post_formdata like getWithdrawHistory uses ApiCaller.post
      const res = await ApiCaller.post_formdata(
        formData,
        urls.uploadExcelFile,
        userData?.access_token
      );

      const response = await res.response.json();

      if (res.status === 200 || response.status === "OK") {
        showToast(`File ${fileName} uploaded successfully!`);
        // We might want to refresh only if it was a bulk upload or if status changes. 
        // For now, refresh always to be safe.
        // setCallAPi(uuidv4()); // Refreshed by markAsProcessing or caller
        return true;
      } else {
        showDangerToast(response.message || "Upload failed");
        return false;
      }

    } catch (error) {
      console.error(error);
      showDangerToast(error.message || "Upload failed");
      return false;
    }
  };

  // --- UPDATE HOLDER NAME HANDLER ---


  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'> <div className='logo'> <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div> </div> </div>
        {viewPermission ? (
          <div className='container-fluid mt--7'>
            <div className='row'> <div className='col text-left'> <div className='card shadow mb-4'>

              {/* --- HEADER --- */}
              <div className='card-header border-0 '>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h3 className='mb-0'>Bank Withdraw Manager</h3>

                  {/* --- NEW ACTION BUTTONS AREA (Professional Look) --- */}
                  <div>
                    {/* Show Total Amount if Pending View */}
                    {datalist && datalist.length > 0 && datalist[0].status === 'PENDING' && (
                      <Typography
                        component="span"
                        sx={{
                          mr: 3,
                          fontWeight: 'bold',
                          fontSize: '1.1rem',
                          color: '#e58d11ff'
                        }}
                      >
                        Total Pending: ₹{formatIndianNumber(datalist.filter(i => i.status === 'PENDING').reduce((acc, item) => acc + (Number(item.finalAmount) || 0), 0))}
                      </Typography>
                    )}

                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => exportToExcel(false)} // Just Download
                      disabled={!datalist || datalist.length === 0}
                      sx={{ mr: 2 }}
                      startIcon={<DownloadIcon />} // If you have icons
                    >
                      Export List
                    </Button>

                    {/* Show Green Button ONLY if Data Status is PENDING */}
                    {datalist && datalist.length > 0 && datalist[0].status === 'PENDING' && (
                      <Button
                        variant="contained"
                        color="success"
                        onClick={handlePrepareSend} // Open Confirmation Modal
                        disabled={!datalist || datalist.length === 0}
                        startIcon={<SendIcon />} // If you have icons
                      >
                        Generate & Send to Bank
                      </Button>
                    )}
                    {/* ranith 2025-12-06 - [Start] - [Process OUT Files Button] */}
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={handleProcessOutFiles}
                      sx={{ ml: 2 }}
                    >
                      Process OUT Files
                    </Button>
                    {/* ranith 2025-12-06 - [End] - [Process OUT Files Button] */}
                  </div>
                </div>

                {/* --- FILTERS ROW --- */}
                <div className='row align-items-center text-left '>
                  {/* Client-side Search with Bootstrap style to match dropdown */}
                  <div className='col-md-3 mb-2'>
                    <Form.Control
                      placeholder='Search by User Name'
                      value={searchText}
                      onChange={e => setSearchText(e.target.value)}
                      style={{ height: '40px' }}
                    />
                  </div>

                  <div className="col-md-3 mb-2"> <TextField type="date" label="Start Date" InputLabelProps={{ shrink: true }} value={startDate} onChange={(e) => setStartDate(e.target.value)} fullWidth size="small" /> </div>
                  <div className="col-md-3 mb-2"> <TextField type="date" label="End Date" InputLabelProps={{ shrink: true }} value={endDate} onChange={(e) => setEndDate(e.target.value)} fullWidth size="small" /> </div>
                  <div className="col-md-2 mb-2">
                    <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} style={{ height: '40px' }}>
                      <option value="ALL">All Status</option>
                      <option value="PENDING">Pending</option>
                      <option value="PROCESSING">Processing</option>
                      <option value="PAID">Paid</option>
                      <option value="REJECTED">Rejected</option>
                    </Form.Select>
                  </div>

                  <div className='col-md-1 mb-2'>
                    <Button variant='contained' onClick={() => {
                      dispatch(clearBankWithdrawCache());
                      if (page === 1) {
                        getWithdrawHistory(false);
                      } else {
                        setPage(1);
                      }
                    }} fullWidth>Filter</Button>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12 text-right'>
                    <Button variant='text' onClick={() => {
                      dispatch(clearBankWithdrawCache());
                      setSearchText('');
                      setStatus('PENDING');
                      setStartDate('');
                      setEndDate('');
                      if (page === 1) {
                        getWithdrawHistory(false, 1, pagerecord.pageSize, '', '', '', 'PENDING');
                      } else {
                        setPage(1);
                      }
                    }}>Reset Filters</Button>
                  </div>
                </div>
              </div>

              <div className='card-body'>
                {pendingUpdates && pendingUpdates.pageNumber === page && (
                  <div className="alert alert-info d-flex justify-content-between align-items-center mb-3 text-dark" style={{ borderRadius: '8px', borderLeft: '5px solid #11cdef' }}>
                    <span>New withdraw requests or status updates are available for this page.</span>
                    <Button 
                      variant="contained" 
                      color="info" 
                      size="small" 
                      onClick={() => {
                        dispatch(updateBankWithdraw(pendingUpdates));
                        setPendingUpdates(null);
                      }}
                    >
                      Update View
                    </Button>
                  </div>
                )}
                <div className='table-responsive'>
                  <table className='table align-items-center table-flush'>
                    <thead className='thead-light'>
                      <tr> <th>#</th> <th>User Name</th> <th>Transaction ID</th> <th>Requested Amt</th> <th>Final Amt</th> <th>Bank Name</th> <th>Account No</th> <th>IFSC</th> <th>Date</th> <th>Status</th> <th>Action</th> </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(datalist) && datalist.length > 0 ?
                        datalist
                          .filter(item => {
                            if (!searchText) return true;
                            // Safe check for userName existence
                            const name = getWithdrawUserName(item);
                            return name.toLowerCase().includes(searchText.toLowerCase());
                          })
                          .map((item, idx) => (
                            <tr key={item.id || idx}>
                              <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + idx + 1}</td>
                              <td>
                                <span
                                  style={{ color: '#1976d2', cursor: 'pointer', fontWeight: 500, textDecoration: 'underline' }}
                                  onClick={() => navigate(`/user-manager/${item.userId || item.id}`)}
                                  title={`View profile of ${getWithdrawUserName(item)}`}
                                >
                                  {getWithdrawUserName(item)}
                                </span>
                              </td>
                              <td style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{getWithdrawTxnId(item)}</td>
                              <td>{formatIndianNumber(item.requestedAmount)}</td> <td>{formatIndianNumber(item.finalAmount)}</td> <td>{item.bankName}</td>
                              {/* Old Code:
                              <td>{item.accountNumber || item.bankAccount}</td>
                              */}
                              {/* New Code: */}
                              <td>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ fontWeight: 500 }}>{item.accountNumber || item.bankAccount}</span>
                                  <span style={{ fontSize: '0.75rem', color: '#8898aa' }}>
                                    ({item.accountHolder || <span style={{ color: '#fb6340' }}>No Holder Name</span>})
                                  </span>
                                </div>
                              </td>
                              <td>{item.ifscCode || item.ifsc}</td> <td>{item.createdAt || item.createdDate}</td>
                              <td> <span className={`badge font-weight-bold ${item.status === 'PAID' ? 'badge-success' : item.status === 'REJECTED' ? 'badge-danger' : item.status === 'PROCESSING' ? 'badge-info' : 'badge-primary'}`}> <span className='text-white'> {item.status} </span> </span> </td>
                              <td>
                                {item.status === 'PENDING' && (
                                  <div className="d-flex gap-2">
                                    <Button variant='contained' color='success' size='small' onClick={() => handleSinglePay(item)} style={{ marginRight: '5px' }}>Pay</Button>
                                    <Button variant='outlined' color='error' size='small' onClick={() => handleRejectClick(item)}>Reject</Button>
                                  </div>
                                )}
                                {item.status === 'PROCESSING' && (
                                  <Button variant='outlined' color='error' size='small' onClick={() => handleRejectClick(item)}>Reject</Button>
                                )}
                                {item.status !== 'PENDING' && item.status !== 'PROCESSING' && <span>--</span>}
                              </td>
                            </tr>
                          )) : (<tr><td colSpan={11} className='text-center'>No Data Found</td></tr>)}
                    </tbody>
                  </table>
                </div>

                {/* --- FOOTER: ONLY PAGINATION (Professional Look) --- */}
                <Box display='flex' justifyContent='flex-end' alignItems='center' mt={3}>
                  <Box display="flex" alignItems="center">
                    <span style={{ marginRight: '10px' }}>Page Size:</span>
                    <TextField type="number" inputProps={{ min: 1, max: 500 }} value={pageSizeInput} onChange={handlePageSizeInputChange} onBlur={handlePageSizeSubmit} onKeyDown={(e) => e.key === "Enter" && handlePageSizeSubmit()} size="small" sx={{ mr: 3, width: 80 }} />
                    <span style={{ marginRight: '15px' }}>Total: {pagerecord?.totalItems}</span>
                    <Pagination count={pagerecord?.totalPages} page={page} onChange={(e, v) => setPage(v)} color='primary' showFirstButton showLastButton />
                  </Box>
                </Box>
              </div>
            </div>
              <Modal open={showRejectModal} onClose={() => setShowRejectModal(false)}>
                <Box sx={style}>
                  <Typography id="modal-modal-title" variant="h6" component="h2" mb={2}>Reject Withdrawal</Typography>
                  <Typography variant="body2" mb={1}>Transaction ID: <strong>{selectedWithdraw?.txnId}</strong></Typography>
                  <Typography variant="body2" mb={2}>Current Status: <strong>{selectedWithdraw?.status}</strong></Typography>
                  <TextField id="outlined-multiline-static" label="Reason / Remarks" multiline rows={4} fullWidth value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} placeholder="Enter reason for rejection..." required />
                  <div className='mt-4 d-flex justify-content-end'> <Button variant="outlined" color="secondary" onClick={() => setShowRejectModal(false)} style={{ marginRight: '10px' }}>Cancel</Button> <Button variant="contained" color="error" onClick={handleSubmitReject}>Confirm Reject</Button> </div>
                </Box>
              </Modal>

              {/* --- CONFIRM SEND MODAL (BULK) --- */}
              <Modal open={showSendModal} onClose={() => setShowSendModal(false)}>
                <Box sx={style}>
                  <Typography id="modal-modal-title" variant="h6" component="h2" mb={2}>
                    Confirm Send to Bank (BULK)
                  </Typography>
                  <Typography variant="body1" mb={1}>
                    You are about to send the withdrawal file to the bank.
                  </Typography>
                  <Divider sx={{ my: 2 }} />
                  <div className="d-flex justify-content-between mb-2">
                    <Typography variant="subtitle1">Total Records:</Typography>
                    <Typography variant="subtitle1" fontWeight="bold">{sendSummary.totalRecords}</Typography>
                  </div>
                  <div className="d-flex justify-content-between mb-3">
                    <Typography variant="h6">Total Amount:</Typography>
                    <Typography variant="h6" color="primary" fontWeight="bold">
                      ₹{formatIndianNumber(sendSummary.totalAmount)}
                    </Typography>
                  </div>
                  <Divider sx={{ my: 2 }} />
                  <div className='mt-4 d-flex justify-content-end'>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => setShowSendModal(false)}
                      style={{ marginRight: '10px' }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => {
                        setShowSendModal(false);
                        exportToExcel(true);
                      }}
                      startIcon={<SendIcon />}
                    >
                      Confirm & Send
                    </Button>
                  </div>
                </Box>
              </Modal>

              {/* --- CONFIRM SINGLE PAY MODAL --- */}
              <Modal open={showSinglePayModal} onClose={() => setShowSinglePayModal(false)}>
                <Box sx={style}>
                  <Typography id="single-pay-modal-title" variant="h6" component="h2" mb={2}>
                    Confirm Single Payment
                  </Typography>
                  <Typography variant="body2" color="error" mb={2}>
                    Warning: This will immediately process the payment for this specific user.
                  </Typography>
                  <Divider sx={{ my: 2 }} />

                  {selectedSinglePayItem && (
                    <>
                      <div className="d-flex justify-content-between mb-1">
                        <Typography variant="subtitle2">User:</Typography>
                        <Typography variant="subtitle2" fontWeight="bold">{getWithdrawUserName(selectedSinglePayItem)}</Typography>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <Typography variant="subtitle2">Bank Account:</Typography>
                        <Typography variant="subtitle2" fontWeight="bold">{selectedSinglePayItem.accountNumber || selectedSinglePayItem.bankAccount}</Typography>
                      </div>
                      <div className="d-flex justify-content-between mb-3">
                        <Typography variant="h6">Amount:</Typography>
                        <Typography variant="h6" color="primary" fontWeight="bold">
                          ₹{formatIndianNumber(selectedSinglePayItem.finalAmount)}
                        </Typography>
                      </div>
                    </>
                  )}

                  <Divider sx={{ my: 2 }} />
                  <div className='mt-4 d-flex justify-content-end'>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => setShowSinglePayModal(false)}
                      style={{ marginRight: '10px' }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={confirmSinglePay}
                      startIcon={<SendIcon />}
                    >
                      Confirm Pay
                    </Button>
                  </div>
                </Box>
              </Modal>
            </div>
          </div>
        </div>
        ) : (<InsufficientPermission />)}
      </div>
    </>
  );
};
export default BankWithdrawManager;